import { defineStore } from 'pinia'
import { get_auth_token } from '@/service/xdvideo'

const createAuthState = () => ({
  app_id: '',
  sign: '',
  noncestr: '',
  timestamp: ''
})

export const useXdvideoStore = defineStore('xdvideo', {
  state: () => ({
    auth: createAuthState(),
    status: false,
    loading: false
  }),
  actions: {
    updateAuth({ status, auth }) {
      this.auth = { ...auth }
      this.status = status
    },
    updateLoading(payload) {
      this.loading = payload
    },
    async asyncGetToken() {
      try {
        if (!this.status && !this.loading) {
          this.updateLoading(true)
          let { app_id, noncestr, sign, timestamp } = await get_auth_token()
          this.updateAuth({
            auth: { app_id, noncestr, sign, timestamp },
            status: true
          })
        }
      } catch (error) {
        this.updateAuth({ status: false, auth: {} })
      }
      this.updateLoading(false)
    }
  }
})
